import './IconPlay.css';
import React from 'react';
const IconHeart = _ref => {
  let {
    width = 12,
    height = 14,
    className = ''
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: `${className} ${styles}`,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 12 14"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66",
    d: "M24.117,32.374V23.626L31.177,28ZM33.576,27.3l-9.882-6.123A1.193,1.193,0,0,0,23.063,21,.983.983,0,0,0,22,21.876V34.124A.983.983,0,0,0,23.063,35a1.19,1.19,0,0,0,.631-.177L33.576,28.7A.79.79,0,0,0,33.576,27.3Z",
    transform: "translate(-22 -21)"
  }));
};
const styles = "sueyvor";
export default IconHeart;